import { render, staticRenderFns } from "./IssueTimeBar.vue?vue&type=template&id=3746a0ed&"
import script from "./IssueTimeBar.vue?vue&type=script&lang=js&"
export * from "./IssueTimeBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports